import Header from '../../../__Layout/Header';
import React, { useState } from 'react';
import * as Yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import { toast } from 'react-toastify';
import Loader from '../../../utils/Loader';
import { useStudentExamCountQuery, useStudentSubmitQuizMutation, useGetstudentMultipleQuestionListQuery, useGetstudentFreeCourseTopicDetailQuery, useGetFreeCourseDetailPdfQuery } from "../../../Services/api";
import { pageUrl } from "../../../utils/constants/constants";
import { Link, useParams } from 'react-router-dom';
import { Document, Page, pdfjs } from 'react-pdf';
import axios from "axios";
import { useSelector, useDispatch } from 'react-redux';
export default function FreeCourseTopicDetails() {
    const { userDetail } = useSelector((state) => state.auth)
    const { lessionId, courseId, subLessionId, sublessonRserial } = useParams();
    const paramSubLessionId = 'subLessionId=' + subLessionId;
    const param = {
        'courseId': courseId,
        'lessionId': lessionId
    };
    const paramQuestion = {
        'sublessonRserial': sublessonRserial,
        'lessonId': lessionId
    };
    const {
        data: MultipleQuestionList,
    } = useGetstudentMultipleQuestionListQuery({ pageUrl, params: paramQuestion });
    const {
        data: StudentExamCount,
    } = useStudentExamCountQuery({ pageUrl, params: courseId });
    const {
        data: studentFreeCourse,
        isLoading: freeCourseDetail,
    } = useGetstudentFreeCourseTopicDetailQuery({ pageUrl, params: param });
    const {
        data: pdf,
        isLoading: pdfLoader,
    } = useGetFreeCourseDetailPdfQuery({ pageUrl, params: paramSubLessionId });

    pdfjs.GlobalWorkerOptions.workerSrc =
        `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;
    const [numPages, setNumPages] = useState(null);
    const [pageNumber, setPageNumber] = useState(1);
    const [countPage, setCountPage] = useState(1);
    function onDocumentLoadSuccess({ numPages }) {
        setNumPages(numPages);
        setPageNumber(countPage);
    }

    const nextPag = async (page) => {
        setCountPage(countPage + page);
        setPageNumber(countPage);
    }
    const previousPage = async (page) => {
        setCountPage(countPage - page);

        setPageNumber(countPage);
    }
    const validationSchema = Yup.object().shape({
        quiz: Yup.string().required("Option fields is required"),
    });
    let defaultValues = { quiz: "" };
    const notify = () => '';
    const methods = useForm({
        mode: "onTouched",
        resolver: yupResolver(validationSchema),
        defaultValues,
    });
    const [StudentSubmitQuiz] = useStudentSubmitQuizMutation();
    const [result, setResult] = useState(2);
    const {
        register,
        handleSubmit,
        formState: { errors },
    } = methods;
    const onSubmit = (values) => {
        StudentSubmitQuiz({ data: values })
            .unwrap()
            .then((payload) => {
                if (payload.status) {

                    toast.success(payload.message)
                    setResult(payload?.data[0]?.multiple_choice_answer);
                } else {
                    toast.error(payload.message)
                }
            })
            .catch((error) => {
                toast.error(error.data.message)
            });
        notify();
    };
    ////////////
    const handleDownload = (courseId) => {
        const token = userDetail?.token;
        const BASE_URL = `${process.env.REACT_APP_BACKEND_URL_LIVE_STUDENT}generate-certificate/${courseId}`;

        axios
            .get(BASE_URL, {
                headers: {
                    'Authorization': `Bearer ${token}`
                },
                responseType: "blob",
            })
            .then((response) => {

                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement("a");
                link.href = url;
                link.setAttribute("download", "certificate.pdf");
                document.body.appendChild(link);
                link.click();

            })
            .catch((error) => {
                console.error("Download failed:", error);
                alert("Error downloading certificate");
            });
    };

    ///////////
    if (freeCourseDetail) return <Loader></Loader>

    return (
        <div className="vehicleCategories">
            <Header />
            <main id="main" className="main">
                <div className="card">
                    <div className="card-body">
                        <h5 className="card-title">My Courses/Training Detail</h5>
                        <ul className="nav nav-tabs nav-tabs-bordered d-flex" id="borderedTabJustified" role="tablist">
                            <li className="nav-item flex-fill" role="presentation">
                                <button className="nav-link w-100 active" id="home-tab" data-bs-toggle="tab" data-bs-target="#bordered-justified-home" type="button" role="tab" aria-controls="home" aria-selected="true">My Courses/Training Details</button>
                            </li>
                            <li>
                                <Link to={`/free-course-topic/${courseId}/${lessionId}`} className='btn btn-dark pull-right'>
                                    Back
                                </Link>
                            </li>

                        </ul>
                        <div className="tab-content pt-2" id="borderedTabJustifiedContent">
                            <div className="tab-pane fade show active" id="bordered-justified-home" role="tabpanel" aria-labelledby="home-tab">
                                <section className="section">
                                    <div className="row">
                                        <div className='col-md-6 col-xs-12 col-sm-12'>

                                            {studentFreeCourse?.SubLesson?.map((item, index) => {

                                                return (
                                                    <ul className="list-group" key={index}>
                                                        <li className='list-group-item"'>
                                                            <Link to={`/free-course-topic-details/${item.coursecode}/${item.lesson_id}/${item.sublesson_id}/${item.sublesson_rserial}`}>
                                                                {item.sublesson_name}
                                                            </Link>
                                                        </li>

                                                    </ul>
                                                )
                                            })
                                            }
                                        </div>

                                        {pdf?.SubLesson?.map((item) => {

                                            return (
                                                <div className='col-md-12 border'>
                                                    <div className="card">
                                                        <div className="card-body">
                                                            {item.sublesson_status == 0 &&
                                                                <>
                                                                    <Document
                                                                        file={item.sublesson_content}
                                                                        onLoadSuccess={onDocumentLoadSuccess}
                                                                    >
                                                                        <Page pageNumber={pageNumber} />
                                                                        <button onClick={e => previousPage(1)} >Previous Page</button>/
                                                                        <button onClick={e => nextPag(1)} >Next Page</button>
                                                                    </Document>
                                                                    <p>
                                                                        Page {pageNumber} of {numPages}
                                                                    </p>
                                                                </>
                                                            }
                                                            {/* Quiz started */}
                                                            {item.sublesson_status == 1 &&
                                                                <>
                                                                    {MultipleQuestionList?.data?.map((item) => {
                                                                        return (
                                                                            <>
                                                                                <h1>Quiz</h1>
                                                                                <p className='m-4'>{item.question_name}</p>
                                                                                <div>
                                                                                    <form onSubmit={handleSubmit(onSubmit)} >
                                                                                        {item?.questions_options?.map((itemQ, index) => {
                                                                                            return (
                                                                                                <div key={itemQ.id} className='ml-4'>
                                                                                                    <input type="radio" {...register("quiz")} className="option" value={itemQ.id} />&nbsp; &nbsp;
                                                                                                    <label className="radiocontainer checkedlabel" id="label1">{itemQ.multiple_choice}</label>
                                                                                                    <span className="text-danger">{errors.quiz?.message}</span>
                                                                                                </div>)

                                                                                        })}
                                                                                        <button className="btn btn-primary ml-4" type="submit" id="confirmBtn">Confirm</button>
                                                                                    </form><br />
                                                                                    {result == 1 &&
                                                                                        <div className="alert alert-success">
                                                                                            <strong>Success!</strong> This Answer Incorrect
                                                                                        </div>
                                                                                    }
                                                                                    {result == 0 &&
                                                                                        <div className="alert alert-danger">
                                                                                            <strong>Danger!</strong> This Answer Incorrect
                                                                                        </div>
                                                                                    }
                                                                                </div>
                                                                            </>
                                                                        )
                                                                    })
                                                                    }
                                                                </>
                                                            }
                                                            {item.sublesson_status == 2 &&
                                                                <>
                                                                    <video width="750" height="500" controls >
                                                                        <source src={item.sublesson_content} type="video/mp4" />
                                                                    </video>
                                                                </>
                                                            }
                                                            {item.sublesson_status == 3 &&
                                                                <>
                                                                    {
                                                                        StudentExamCount?.data?.examcount == 0 &&
                                                                        <>
                                                                            <p style={{ fontWeight: "bold", fontSize: "35px", color: "green" }}>Final Assessment </p>
                                                                            <p style={{ fontWeight: "bold", fontSize: "35px" }}>
                                                                                <Link to={`/take-quiz/${courseId}/${lessionId}/${subLessionId}/${sublessonRserial}`} className='btn btn-dark pull-right m-4'>
                                                                                    Please click if you are ready
                                                                                </Link>
                                                                            </p>
                                                                        </>

                                                                    }
                                                                    {
                                                                        (StudentExamCount?.data?.examcount >= 1 && StudentExamCount?.data?.status == 1) &&
                                                                        <>
                                                                            <p style={{ fontWeight: "bold", fontSize: "20px", color: "green" }}>Good Job!</p>
                                                                            <p style={{ fontWeight: "bold", fontSize: "20px", color: "green" }}>You passed the final assessment with a score of</p>
                                                                            <p style={{ fontWeight: "bold", fontSize: "35px", color: "green" }}>{StudentExamCount?.data?.totalpercentage}%</p>
                                                                            <p style={{ fontWeight: "bold", fontSize: "30px" }}>
                                                                                {
                                                                                    StudentExamCount?.data?.Course?.[0]?.course_type !== 1 ?


                                                                                        <>
                                                                                            {/* <a target="_blank" href={`https://elearning.qhseinternational.com/index.php?student/online_exam/generate_certificate/${StudentExamCount?.data?.studentId}/${courseId}`} className='btn btn-dark pull-right m-4'>
                                                                                                GET YOUR CERTIFICATE
                                                                                            </a> */}
                                                                                             
                                                                                            {/* <a target="_blank" href={`${process.env.REACT_APP_BACKEND_URL_LIVE_STUDENT}generate-certificate/${StudentExamCount?.data?.studentId}/${courseId}`} className='btn btn-dark pull-right m-4'>
                                                                                                GET YOUR CERTIFICATE
                                                                                            </a> */}
                                                                                             <button className='btn btn-dark pull-right m-4' onClick={()=>handleDownload(courseId)}>
                                                                                                    🎓 GET YOUR CERTIFICATE
                                                                                                </button>


                                                                                        </>


                                                                                        :
                                                                                        <p style={{ fontWeight: "bold", fontSize: "15px", color: "green" }} className="alert alert-danger"> For your Certificate Collection please contact our office.<br />Email : admin@qhseinternational.com , Mobile : +97144431124/+971507772173</p>

                                                                                }
                                                                            </p>
                                                                        </>

                                                                    }
                                                                    {
                                                                        (StudentExamCount?.data?.examcount >= 1 && StudentExamCount?.data?.status == 0) &&
                                                                        <>
                                                                            <p style={{ fontWeight: "bold", fontSize: "20px", color: "red" }}> You fail the final assessment with a score of</p>
                                                                            <p style={{ fontWeight: "bold", fontSize: "35px", color: "green" }}>{StudentExamCount?.data?.totalpercentage}%</p>
                                                                            <p style={{ fontWeight: "bold", fontSize: "30px" }}>
                                                                                <Link to={`/take-quiz/${courseId}/${lessionId}/${subLessionId}/${sublessonRserial}`} className='btn btn-dark pull-right m-4'>
                                                                                    Click here to repeat the Assessment
                                                                                </Link>
                                                                              

                                                                            </p>
                                                                        </>

                                                                    }
                                                                    
                                                                    {

                                                                        (StudentExamCount?.data?.status == 1 && StudentExamCount?.data?.havegencertficate == 1) &&
                                                                        <>


                                                                            {/* <a target="_blank" href={`${process.env.REACT_APP_BACKEND_URL_LIVE_STUDENT}generate-certificate/${StudentExamCount?.data?.studentId}/${courseId}`} className='btn btn-dark pull-right m-4'>
                                                                                    GET YOUR CERTIFICATE
                                                                                </a> */}
                                                                            {/* <a target="_blank" href={`https://elearning.qhseinternational.com/index.php?student/online_exam/generate_certificate/${StudentExamCount?.data?.studentId}/${courseId}`} className='btn btn-dark pull-right m-4'>
                                                                                GET YOUR CERTIFICATE
                                                                            </a> */}
                                                                             <button className='btn btn-dark pull-right m-4' onClick={()=>handleDownload(courseId)}>
                                                                                🎓 GET YOUR CERTIFICATE
                                                                            </button>

                                                                        </>
                                                                    }

                                                                </>
                                                            }
                                                        </div>
                                                    </div>

                                                </div>
                                            )
                                        })
                                        }

                                    </div>
                                </section>
                            </div>
                        </div>
                    </div>
                </div>
            </main>
        </div>
    );
}
